import { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { updateCurrentStoreById } from '../../../actions/storeActions';

import useAxios from '../../../axios/useAxios';
import { notifyError, notifySuccess } from '../../../utils/Notify';

import { FaArrowRight } from 'react-icons/fa6';

import { changeCartStore } from '../../../actions/cartActions';
import { useLocalStorage } from '../../../hooks/useLocalStorage';

export const CardStore = ({ orderId, storeId, title, description, image, setIsOpen, setCode, setProduct }) => {
  const axiosInstance = useAxios();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user);

  const [isLoading, setIsLoading] = useState(false);
  const [, setIsCheckStore] = useLocalStorage('isCheckStore');
  const [, setIsCheckStoreAlreadyAsk] = useLocalStorage('isCheckStoreAlreadyAsk');

  const selectStore = async () => {
    setIsLoading(true)

    if (!storeId) {
      const titleNotif = 'Erreur sélection magasin'
      const descriptionNotif = 'Aucun magasin sélectionné'
      notifyError(titleNotif, descriptionNotif, null, 3000);

      setIsOpen(false);

      setTimeout(() => {
        setIsCheckStoreAlreadyAsk(null);
        setIsCheckStore('true');
      }, 500);

      return;
    }

    function updateCartStore () {
      try {
        dispatch(changeCartStore(orderId, storeId, axiosInstance));
      } catch (e) {
        console.error("OrderChangeStore", e);
      }
    }

    dispatch(updateCurrentStoreById(storeId, axiosInstance))
      .then(() => {
        const titleNotif = 'Magasin changé avec succès'
        const descriptionNotif = 'Tu peux continuer à scanner vos articles'
        notifySuccess(titleNotif, descriptionNotif);

        setTimeout(() => {
          setIsOpen(false);
          setIsCheckStore(null);
          setIsCheckStoreAlreadyAsk('true');
          setCode(0);
          setProduct(false);
        }, 200);

        updateCartStore()
      })
      .catch((error) => {
        console.error("selectStore - Modal Géoloc", error);

        const titleNotif = 'Erreur sélection magasin'
        const descriptionNotif = 'Impossible de charger le magasin sélectionné, réessayer'
        notifyError(titleNotif, descriptionNotif, null, 3000);

        setIsOpen(false);

        setTimeout(() => {
          setIsCheckStore('true');
        }, 500);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <button
      type="button"
      className="flex justify-between items-center p-4 mt-4 mb-6 rounded-2xl w-full cursor-pointer"
      style={{ border: '1px solid #ebe6e6', borderStyle: 'solid' }}
      onClick={selectStore}
      disabled={isLoading}
    >
      <div className="flex justify-center items-center rounded-2xl bg-[#F4F4F4]">
        <img src={image} alt="wrongStorePikko" className="w-24 h-24 object-contain" />
      </div>

      <div className="text-left flex-1 ml-4">
        <h2 className="mb-1 text-2xl">{title}</h2>
        <p>{description}</p>
      </div>

      <div className="flex items-center justify-center rounded-lg p-4 bg-gradient-to-br from-[#e1ff26] from-15% to-[#fffb26]">
        <FaArrowRight size={16} />
      </div>
    </button>
  );
};
